/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const serviceQualityContractualDeviationEnumsAffectedSLAMetricOptionEnum = {
    Availability: 'Availability',
    ResponseTime: 'ResponseTime',
    PerformanceThreshold: 'PerformanceThreshold',
    Capacity: 'Capacity',
    Other: 'Other',
} as const;

export type ServiceQualityContractualDeviationEnumsAffectedSLAMetricOptionEnumKey =
    (typeof serviceQualityContractualDeviationEnumsAffectedSLAMetricOptionEnum)[keyof typeof serviceQualityContractualDeviationEnumsAffectedSLAMetricOptionEnum];

export type ServiceQualityContractualDeviationEnumsAffectedSLAMetricOption =
    ServiceQualityContractualDeviationEnumsAffectedSLAMetricOptionEnumKey;
